import React from 'react'
import { checkIfTriggerIsUsed } from './deleteChecks'
import { useMutation } from '@apollo/client'
import { GET_ALL_APPLICATIONS } from '../../../../graphql/query'
import { DELETE_APPLICATION_INTENT } from '../../../../graphql/mutation'
import { toast } from 'react-toastify'
import axios from 'axios'

interface IProps {
  intent: any
  inputJson: any[]
  setInputJson: React.Dispatch<React.SetStateAction<any[]>>
  closeModal: () => void
  data: any
}

const DeleteInstaIntent: React.FC<IProps> = ({
  inputJson,
  setInputJson,
  intent,
  closeModal,
  data
}) => {
  const { status, intentId } = checkIfTriggerIsUsed(intent.id, inputJson)
  console.log(data)
  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem('auth-token')
      if (!token) {
        toast.error('No auth token found. Please log in again.')
        return
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_RESUME_PARSER_URL}/deleteInstagramApplicationIntentByIntentId`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            applicationId: parseInt(data?.id),
            intentId: intent.id
          }
        }
      )

      if (response.status >= 200 && response.status < 300) {
        toast.success('Intent deleted successfully!')
        const newInputJson = inputJson.filter((item: any) => item.id !== intent.id)
        setInputJson(newInputJson)
      } else {
        toast.error('Failed to delete the intent.')
      }
    } catch (err: any) {
      console.error(err)
      toast.error(err?.response?.data?.message || 'Oops! Something went wrong.')
    } finally {
      closeModal()
    }
  }

  let content
  if (!!intent.start || !!intent.end) {
    content = (
      <div>
        {!!intent.start ? (
          <p className='fs-5 fw-bold'>Oops! You can't delete the start intent.</p>
        ) : (
          <p className='fs-5 fw-bold'>Oops! You can't delete the end intent.</p>
        )}
        <div className='d-flex justify-content-end mt-10'>
          <button type='reset' className='btn btn-sm btn-secondary' onClick={closeModal}>
            Okay. Got it!
          </button>
        </div>
      </div>
    )
  } else if (!!status) {
    content = (
      <>
        <p className='fs-5 fw-bold'>{`Oops! This intent is already being called in another Intent with id: ${intentId}`}</p>
        <div className='d-flex justify-content-end mt-10'>
          <button type='reset' className='btn btn-sm btn-secondary' onClick={closeModal}>
            Okay. Got it!
          </button>
        </div>
      </>
    )
  } else {
    content = (
      <>
        <p className='fs-5 fw-bold'>{`Are you sure you want to delete the intent with id: ${intent.id}`}</p>
        <div className='d-flex justify-content-end mt-10'>
          <button
            type='reset'
            className='btn btn-sm btn-white btn-active-light-primary me-2'
            onClick={closeModal}
          >
            Cancel
          </button>
          <button type='submit' className='btn btn-sm btn-danger' onClick={handleSubmit}>
            Delete
          </button>
        </div>
      </>
    )
  }

  return <div>{content}</div>
}

export default DeleteInstaIntent
